import React from 'react'
import Tooltip from '../Tooltip/Tooltip'
import './ProgressBar.scss'
import { i18n } from '../../services/i18n'

type Props = {
  progress: number,
  absolut: number
}

type State = {

}

export default class ProgressBar extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
  }
  
  pepTalk(progress: number): string {
    if (progress < 5) { return i18n('progress.lt5') }
    if (progress < 20) { return i18n('progress.lt20') }
    if (progress < 30) { return i18n('progress.lt30') }
    if (progress < 50) { return i18n('progress.lt50') }
    if (progress < 66) { return i18n('progress.lt66') }
    if (progress < 90) { return i18n('progress.lt90') }
    if (progress < 100) { return i18n('progress.lt100') }
    return i18n('progress.eq100')
  }
  render () {
    const progress = 100 * this.props.progress / this.props.absolut
    return <div className={`ProgressBar`}>
        <Tooltip content={this.pepTalk(progress)} />
        <div className={`BarHolder`}>
          <div className={`Bar`}
            style={{
              width: `${progress}%`
            }}
          >

          </div>
        </div>
        <div className={`ProgressBarLabel`}>
          {this.props.progress} / {this.props.absolut}
        </div>
      </div>
  }
}
